import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CEmptyState',
  props: {
    message: { default: "There's nothing here yet" },
    messageStyle: { default: '' },
    icon: { default: 'fa-solid fa-circle-info' },
    iconClass: { default: 'icon' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})